import {Spinner} from "react-bootstrap";

import "./styles.css";

const Loading = () => {
    return (
        <div className="app-loading">
            <p>در حال بارگذاری اطلاعات</p>
           <Spinner 
                as="span"
                animation="border"
                size="lg"
                role="status"
                aria-hidden="true"
            />
        </div>
    );
};
export default Loading;